import Step from "./Step";

/**
 * Class representing Step 2 in the registration process.
 * @extends Step
 */
class Step2 extends Step {
    /**
     * Create Step 2.
     */
    constructor() {
        super(2, 'verification', $(`[data-register-step="verification"]`)); // Initialize with step name

        this.resendButton = this.element.find('#resend_button'); // Find the resend button
        this.verifyButton = this.element.find('#verify_btn'); // Find the verify button
        this.emailField = this.element.find('#email_field'); // Find the email field
        this.errorRegion = this.element.find('#verification_error');
    }

    /**
     * Initialize Step 2.
     */
    init() {
        this.initTwoFactor(); // Initialize two-factor authentication setup
    }

    /**
     * Verify the email using an API call, email is stored in the users session.
     * @async
     * @returns {Promise<boolean>} - True if the email is verified, false otherwise.
     */
    async verifyEmail() {
        try {
            let data = await API.post("/register/verifyEmail", {
                key: this.element.find('#2fainput').val(),
            });

            if (data.status === 200) {
                this.hideError();
                window.register.initUser(data.user);
                return true;
            } else {
                throw new Error(data.error.responseJSON.message);
            }
        } catch (error) {
            this.showError(error.message);
            return false;
        }
    }

    showError(message) {
        this.errorRegion.text(message).show();
    }

    hideError() {
        this.errorRegion.text('').hide();
    }

    /**
     * Initialize two-factor authentication input and event handlers.
     */
    initTwoFactor() {
        const faInput = $("#2fainput");
        const inputs = $("#input_range input");
        const submitBtn = $("#verify_btn");

        faInput.focus();
        this.handleInputEvents(faInput, inputs, submitBtn);
        this.handleDocumentEvents(faInput);
        this.handleVerifyButtonClick();
        this.handleResendButtonClick();

        this.emailField.text(window.register.authUser.email);
    }

    /**
     * Handle input events for the two-factor authentication input.
     * @param {Object} faInput - The two-factor input element.
     * @param {Object} inputs - The range of input elements.
     * @param {Object} submitBtn - The submit button element.
     */
    handleInputEvents(faInput, inputs, submitBtn) {
        faInput.on('keyup change', function () {
            console.log('keyup change');

            const value = $(this).val();

            inputs.val('').removeClass('active');
            submitBtn.removeClass('active');

            for (let i = 0; i < value.length; i++) {
                $(inputs[i]).val(value[i]);
            }

            if (value.length === 6) {
                submitBtn.addClass('active');
            } else if (value.length < 6) {
                $(inputs[value.length]).addClass('active');
            }
        });

        inputs.on("click", function () {
            faInput.focus();
        });
    }

    /**
     * Handle document keydown events.
     * @param {Object} faInput - The two-factor input element.
     */
    handleDocumentEvents(faInput) {
        // make paste event work, on document level
        $(document).off('paste').on('paste', (e) => {
            if (window.register && window.register.currentStep !== this) {
                return;
            }

            e.preventDefault();
            const text = e.originalEvent.clipboardData.getData('text');
            faInput.val(text.replace(/\D/g, '').slice(0, 6));
            faInput.trigger('change');
        });

        $(document).off('keydown').on('keydown', (e) => {
            // handler is bound on document, ignore keys once another step is active
            if (window.register && window.register.currentStep !== this) {
                return;
            }

            // leave other form fields alone
            if (e.target !== faInput[0] && $(e.target).is('input, textarea, select')) {
                return;
            }

            // focus the hidden input so the browser types digits / backspace natively (writing the
            // value ourselves as well made every digit appear twice while the input had focus)
            faInput.focus();

            if (e.key === 'Enter') {
                $("#verify_btn").click();
            }
        });
    }

    /**
     * Handle verify button click event.
     */
    handleVerifyButtonClick() {
        console.log(this.resendButton);
        this.verifyButton.off('click').on('click', async () => {
            const code = $("#2fainput").val();
            this.verifyButton.attr('data-kt-indicator', 'on');

            if (code.length === 6) {
                if (await this.verifyEmail()) {
                    register.goNext(); // Proceed to the next step on successful verification
                }
            } else {
                this.showError('Vul alle 6 cijfers in'); // Display error message for incomplete code
            }

            this.verifyButton.attr('data-kt-indicator', 'off');
        });
    }

    handleResendButtonClick() {
        this.resendButton.off('click').on('click', async () => {
            this.resendButton.attr('data-kt-indicator', 'on');
            await this.resendEmail();
            this.resendButton.attr('data-kt-indicator', 'off');
        });
    }

    async resendEmail() {
        try {
            let data = await API.post("/register/resendEmail");

            if (data.status === 200) {
                message.success('Email is verzonden, controleer uw inbox.');
            } else {
                throw new Error(data.error.responseJSON.message);
            }
        } catch (error) {
            message.error(error.message);
        }
    }

    /**
     * Check if Step 2 is complete.
     * @async
     * @returns {Promise<boolean>} - False indicating the step is not complete.
     */
    async isComplete() {
        return false;
    }
}

export default Step2;
